// extracted by mini-css-extract-plugin
export default {"container":"stats-count_container__3iE-m","isContainer":"stats-count_isContainer__3GFoX","box":"stats-count_box__1ytG5"};